import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getCampaignDetailsForDashboardFailure, getCampaignDetailsForDashboardSuccess } from '../../actions/InfluencerCampaignActions/getCampaignDetailsForDashboardActions';

function* getCampaignDetailsForDashboard({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getCampaignDetailsForDashboard + `?platform=${payload.platform}`,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_SUCCESS status :", response.data.status);
        console.log("GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_SUCCESS data :", response.data.response);
        console.log("GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getCampaignDetailsForDashboardSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_FAILURE status :", error?.response?.status);
        console.log("GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_FAILURE data:", error?.response?.data);
        console.log("GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_FAILURE error :", error);
        console.log('====================================');
        yield put(getCampaignDetailsForDashboardFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getCampaignDetailsForDashboardSaga() {
    yield takeLatest(actionTypes.GET_CAMPAIGN_DETAILS_FOR_DASHBOARD_REQUEST, getCampaignDetailsForDashboard);
}

export default getCampaignDetailsForDashboardSaga;
